module.exports = __webpack_public_path__ + "img/send_mob_dia.png";